<div class="nerf-simulator-container">
  <form [formGroup]="simulatorForm" (ngSubmit)="onSubmit()">
    <div class="container-fluid px-0">

      <!-- Two Column Layout: Editable vs Read-Only -->
      <div class="row">
        <!-- LEFT COLUMN: EDITABLE PARAMETERS -->
        <div class="col-12 col-lg-6">
          <div class="parameters-table editable-section">
            <div class="section-main-header section-title-purple">
              <mat-icon class="section-icon mr-2" aria-hidden="true">edit</mat-icon>
              {{ 'components.nerf-simulator.editable_parameters' | translate }}
            </div>

            <!-- Un solo table-section per card: tutti i campi modificabili -->
            <div class="table-section">
              <div class="table-grid-single">
                <div class="table-row-single">
                  <label class="table-label">{{ 'components.nerf-simulator.rituximab_composition' | translate }}</label>
                  <input type="number" class="table-input" formControlName="rituximab_composition" step="0.1"
                    [class.is-invalid]="simulatorForm.errors?.['compositionSumExceeded']">
                  <span class="table-unit">%</span>
                </div>
                <div class="table-row-single">
                  <label class="table-label">{{ 'components.nerf-simulator.ocrelizumab_composition' | translate }}</label>
                  <input type="number" class="table-input" formControlName="ocrelizumab_composition" step="0.1"
                    [class.is-invalid]="simulatorForm.errors?.['compositionSumExceeded']">
                  <span class="table-unit">%</span>
                </div>
                <div class="table-row-single">
                  <label class="table-label">{{ 'components.nerf-simulator.ublituximab_composition' | translate }}</label>
                  <input type="number" class="table-input" formControlName="ublituximab_composition" step="0.1"
                    [class.is-invalid]="simulatorForm.errors?.['compositionSumExceeded']">
                  <span class="table-unit">%</span>
                </div>
              <!-- Composition Sum Validation Error -->
              @if (simulatorForm.errors?.['compositionSumExceeded']) {
                <div class="alert alert-danger mt-2" role="alert">
                  <i class="icon-Alert-Triangle mr-2"></i>
                  <strong>{{ 'components.nerf-simulator.composition_sum_error_message' | translate }}</strong>
                  ({{ simulatorForm.errors?.['compositionSumExceeded'].sum | number:'1.0-2' }}% / {{ simulatorForm.errors?.['compositionSumExceeded'].max }}%)
                </div>
              }

              <!-- Operational (Gap_Min, …) -->
              <!-- <h5 class="section-header">{{ 'components.nerf-simulator.operational_parameters' | translate }}</h5> -->
                <div class="table-row-single">
                  <label class="table-label">{{ 'components.nerf-simulator.gap_min' | translate }}</label>
                  <input type="number" class="table-input" formControlName="Gap_Min" step="1">
                  <span class="table-unit">min</span>
                </div>
                <!--
                  DEV / UX: campo nascosto (non eliminare senza decisione esplicita).
                  Il FormControl `Avg_Infusion_Min_Scenario` resta in nerf-simulator.component.ts e partecipa ancora a getRawValue()/submit.
                <div class="table-row-single">
                  <label class="table-label">{{ 'components.nerf-simulator.avg_infusion_min_scenario' | translate }}</label>
                  <input type="number" class="table-input" formControlName="Avg_Infusion_Min_Scenario" step="1">
                  <span class="table-unit">min</span>
                </div>
                -->
                <!--
                  DEV / UX: campo nascosto (non eliminare senza decisione esplicita).
                  Il FormControl `Gap_TimeHours_Per_Day` resta in nerf-simulator.component.ts e partecipa ancora a getRawValue()/submit.
                <div class="table-row-single">
                  <label class="table-label">{{ 'components.nerf-simulator.gap_time_hours_per_day' | translate }}</label>
                  <input type="number" class="table-input" formControlName="Gap_TimeHours_Per_Day" step="0.5">
                  <span class="table-unit">h</span>
                </div>
                -->

              <!-- Staff & Capacity -->
                <div class="table-row-single">
                  <label class="table-label">{{ 'components.nerf-simulator.nurses_per_shift' | translate }}</label>
                  <input type="number" class="table-input" formControlName="Nurses_per_Shift" step="1">
                  <span class="table-unit"></span>
                </div>
                <div class="table-row-single">
                  <label class="table-label">{{ 'components.nerf-simulator.patients_per_nurse' | translate }}</label>
                  <input type="number" class="table-input" formControlName="Patients_per_Nurse" step="1">
                  <span class="table-unit"></span>
                </div>
                <div class="table-row-single">
                  <label class="table-label">{{ 'components.nerf-simulator.chairs_active' | translate }}</label>
                  <input type="number" class="table-input" formControlName="Chairs_Active" step="1">
                  <span class="table-unit"></span>
                </div>
                <div class="table-row-single">
                  <label class="table-label">{{ 'components.nerf-simulator.number_of_opening_days' | translate }}</label>
                  <input type="number" class="table-input" formControlName="number_of_opening_days" step="1">
                  <span class="table-unit">days</span>
                </div>
                <div class="table-row-single">
                  <label class="table-label">{{ 'components.nerf-simulator.infusion_service_hours' | translate }}</label>
                  <input type="number" class="table-input" formControlName="infusion_service_hours" step="0.5">
                  <span class="table-unit">h</span>
                </div>
              </div>
            </div>

            <!-- Parametri avanzati (fondo box "Parametri di ingresso"): Safety_Buffer + No_Show_Rate -->
            <div class="table-section nerf-editable-advanced-section">
              <mat-accordion class="expansion-panels-cards nerf-editable-advanced-accordion" multi="false">
                <mat-expansion-panel class="expansion-panel-card">
                  <mat-expansion-panel-header>
                    <mat-panel-title class="d-flex align-items-center">
                      <mat-icon class="section-icon mr-2" aria-hidden="true">tune</mat-icon>
                      {{ 'components.nerf-simulator.advanced_parameters' | translate }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="table-grid-single nerf-advanced-panel-fields">
                    <div class="table-row-single">
                      <label class="table-label">{{ 'components.nerf-simulator.safety_buffer' | translate }}</label>
                      <input type="number" class="table-input" formControlName="Safety_Buffer" step="0.01">
                      <span class="table-unit">%</span>
                    </div>
                    <div class="table-row-single">
                      <label class="table-label">{{ 'components.nerf-simulator.no_show_rate' | translate }}</label>
                      <input type="number" class="table-input" formControlName="No_Show_Rate" step="0.01" min="0" max="100">
                      <span class="table-unit">%</span>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </div>
        </div>

        <!-- RIGHT COLUMN: READ-ONLY PARAMETERS -->
        <div class="col-12 col-lg-6">
          <div class="parameters-table readonly-section">
            <div class="section-main-header section-title-purple">
              <mat-icon class="section-icon mr-2" aria-hidden="true">lock</mat-icon>
              {{ 'components.nerf-simulator.readonly_parameters' | translate }}
            </div>

            <!-- Medication Duration -->
            <div class="table-section">
              <!-- <h5 class="section-header">{{ 'components.nerf-simulator.medication_parameters' | translate }}</h5> -->
              <div class="table-grid-single">
                <div class="table-row-single">
                  <label class="table-label">{{ 'components.nerf-simulator.rituximab_min' | translate }}</label>
                  <input type="number" class="table-input" formControlName="rituximab_min" step="1">
                  <span class="table-unit">min</span>
                </div>
                <div class="table-row-single">
                  <label class="table-label">{{ 'components.nerf-simulator.ocrelizumab_min' | translate }}</label>
                  <input type="number" class="table-input" formControlName="ocrelizumab_min" step="1">
                  <span class="table-unit">min</span>
                </div>
                <div class="table-row-single">
                  <label class="table-label">{{ 'components.nerf-simulator.ublituximab_min' | translate }}</label>
                  <input type="number" class="table-input" formControlName="ublituximab_min" step="1">
                  <span class="table-unit">min</span>
                </div>
              </div>
            </div>

            <!--
              DEV / UX: sezione "Working hours" nascosta (non eliminare senza decisione esplicita).
              FormControls: Hours_Per_Day, Working_Days_Month, avg_patients_per_chair_per_day — definiti e disabilitati in .ts; inclusi in getRawValue()/submit.
            <div class="table-section">
              <div class="table-grid-single">
                <div class="table-row-single">
                  <label class="table-label">{{ 'components.nerf-simulator.hours_per_day' | translate }}</label>
                  <input type="number" class="table-input" formControlName="Hours_Per_Day" step="0.5">
                  <span class="table-unit">h</span>
                </div>
                <div class="table-row-single">
                  <label class="table-label">{{ 'components.nerf-simulator.working_days_month' | translate }}</label>
                  <input type="number" class="table-input" formControlName="Working_Days_Month" step="1">
                  <span class="table-unit">days</span>
                </div>
                <div class="table-row-single">
                  <label class="table-label">{{ 'components.nerf-simulator.avg_patients_per_chair_per_day' | translate }}</label>
                  <input type="number" class="table-input" formControlName="avg_patients_per_chair_per_day" step="0.01">
                  <span class="table-unit"></span>
                </div>
              </div>
            </div>
            -->

            <!-- Tempi (sola lettura): stesso titolo e icona del pannello "Parametri avanzati" a sinistra -->
            <div class="table-section nerf-readonly-fixed-section">
              <mat-accordion class="expansion-panels-cards nerf-readonly-fixed-accordion" multi="false">
                <mat-expansion-panel class="expansion-panel-card">
                  <mat-expansion-panel-header>
                    <mat-panel-title class="d-flex align-items-center">
                      <mat-icon class="section-icon mr-2" aria-hidden="true">tune</mat-icon>
                      {{ 'components.nerf-simulator.advanced_parameters' | translate }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="table-grid-single nerf-fixed-panel-fields">
                    <div class="table-row-single">
                      <label class="table-label">{{ 'components.nerf-simulator.prep_time_chair_materials' | translate }}</label>
                      <input type="number" class="table-input" formControlName="prep_time_chair_materials" step="0.01">
                      <span class="table-unit">min</span>
                    </div>
                    <div class="table-row-single">
                      <label class="table-label">{{ 'components.nerf-simulator.patient_reception_assessment_time' | translate }}</label>
                      <input type="number" class="table-input" formControlName="patient_reception_assessment_time" step="0.01">
                      <span class="table-unit">min</span>
                    </div>
                    <div class="table-row-single">
                      <label class="table-label">{{ 'components.nerf-simulator.vitals_premedication_setup_time' | translate }}</label>
                      <input type="number" class="table-input" formControlName="vitals_premedication_setup_time" step="0.01">
                      <span class="table-unit">min</span>
                    </div>
                    <div class="table-row-single">
                      <label class="table-label">{{ 'components.nerf-simulator.post_infusion_surveillance_time' | translate }}</label>
                      <input type="number" class="table-input" formControlName="post_infusion_surveillance_time" step="0.01">
                      <span class="table-unit">min</span>
                    </div>
                    <div class="table-row-single">
                      <label class="table-label">{{ 'components.nerf-simulator.post_infusion_admin_time' | translate }}</label>
                      <input type="number" class="table-input" formControlName="post_infusion_admin_time" step="0.01">
                      <span class="table-unit">min</span>
                    </div>
                    <div class="table-row-single">
                      <label class="table-label">{{ 'components.nerf-simulator.avg_operational_gap_between_infusions' | translate }}</label>
                      <input type="number" class="table-input" formControlName="avg_operational_gap_between_infusions" step="0.01">
                      <span class="table-unit">min</span>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </div>
        </div>
      </div>

      <!-- Action Buttons Section -->
      <div class="row my-4">
        <div class="col-12">
          <div class="nerf-form-actions">
            <button mat-stroked-button color="primary" type="button" class="nerf-form-actions__btn"
              (click)="onReset()" [disabled]="loading">
              {{ 'components.nerf-simulator.reset_parameters' | translate }}
            </button>
            <button mat-raised-button color="primary" type="submit" class="nerf-form-actions__btn"
              [disabled]="simulatorForm.invalid || loading">
              <mat-icon class="mr-2" aria-hidden="true">auto_fix_high</mat-icon>
              {{ 'generic.buttons.simulate' | translate }}
            </button>
          </div>
        </div>
      </div>

      <!-- Loading: sotto ai pulsanti, sopra allo storico, spinner + testo centrati e viola -->
      @if (loading) {
        <div class="row my-3">
          <div class="col-12">
            <div class="loading-container nerf-simulate-loading">
              <mat-spinner diameter="44" color="primary" aria-hidden="true"></mat-spinner>
              <p>{{ 'components.nerf-simulator.loading' | translate }}</p>
            </div>
          </div>
        </div>
      }

      <!-- Simulation History Section (stesso pattern survey-details: expansion-panel + tabella) -->
      @if (simulationHistory.length > 0) {
        <div class="row my-4">
          <div class="col-12">
            <mat-accordion class="expansion-panels-cards" multi>
              <mat-expansion-panel class="expansion-panel-card" [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title class="d-flex align-items-center">
                    <mat-icon class="section-icon mr-2" aria-hidden="true">history</mat-icon>
                    {{ 'components.nerf-simulator.simulation_history' | translate }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="table-container-rounded">
                  <table mat-table [dataSource]="simulationHistory" class="w-100 table-primary">
                    <ng-container matColumnDef="created_at">
                      <th mat-header-cell *matHeaderCellDef>{{ 'components.nerf-simulator.simulation_date' | translate }}</th>
                      <td mat-cell *matCellDef="let simulation">{{ simulation.created_at | date:'short' }}</td>
                    </ng-container>
                    <ng-container matColumnDef="utilization_percent">
                      <th mat-header-cell *matHeaderCellDef>{{ 'components.nerf-simulator.utilization_percent' | translate }}</th>
                      <td mat-cell *matCellDef="let simulation">{{ simulation.output_results?.utilization_percent | number:'1.2-2' }}%</td>
                    </ng-container>
                    <ng-container matColumnDef="patients_per_month">
                      <th mat-header-cell *matHeaderCellDef>{{ 'components.nerf-simulator.patients_per_month' | translate }}</th>
                      <td mat-cell *matCellDef="let simulation">{{ simulation.output_results?.patients_per_month | number:'1.0-0' }}</td>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                      <th mat-header-cell *matHeaderCellDef class="right">{{ 'components.nerf-simulator.actions' | translate }}</th>
                      <td mat-cell *matCellDef="let simulation" class="right" (click)="$event.stopPropagation()">
                        <button mat-button color="primary" type="button" class="mr-2"
                          (click)="loadSimulation(simulation); $event.stopPropagation();">
                          <small>{{ 'generic.view' | translate }}</small>
                          <mat-icon iconPositionEnd>visibility</mat-icon>
                        </button>
                        <button mat-button color="primary" type="button" class="mr-2"
                          (click)="exportToExcel(simulation.id); $event.stopPropagation();">
                          <small>{{ 'generic.export-data' | translate }}</small>
                          <mat-icon iconPositionEnd>file_download</mat-icon>
                        </button>
                        <button mat-button color="warn" type="button"
                          (click)="handleDeleteClick($event, simulation.id)">
                          <small>{{ 'generic.delete' | translate }}</small>
                          <mat-icon iconPositionEnd>delete</mat-icon>
                        </button>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="historyDisplayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: historyDisplayedColumns;"></tr>
                  </table>
                </div>
                @if (loadingHistory) {
                  <div class="text-center mt-3 pb-2">
                    <mat-spinner diameter="30"></mat-spinner>
                  </div>
                }
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
      }

      <!-- Risultati simulazione: stesso shell dello storico (accordion + table-container-rounded) -->
      @if (hasResult && !loading) {
        <div id="nerf-simulation-results-anchor" class="row my-4">
          <div class="col-12">
            <mat-accordion class="expansion-panels-cards" multi>
              <mat-expansion-panel class="expansion-panel-card" [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title class="d-flex align-items-center">
                    <mat-icon class="section-icon mr-2" aria-hidden="true">check_circle</mat-icon>
                    {{ 'components.nerf-simulator.results_title' | translate }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="table-container-rounded">
                  <div class="nerf-results-inner">
                    <div class="row kpi-section mb-4">
                      <div class="col-12">
                        <h4 class="section-title section-title-purple">
                          <mat-icon class="section-icon mr-2" aria-hidden="true">analytics</mat-icon>
                          {{ 'components.nerf-simulator.key_metrics' | translate }}
                        </h4>
                      </div>
                      <div class="col-12 col-md-6 col-lg-3 mb-3">
                        <div class="kpi-card kpi-primary">
                          <div class="kpi-icon">
                            <mat-icon aria-hidden="true">percent</mat-icon>
                          </div>
                          <div class="kpi-content">
                            <div class="kpi-label">{{ 'components.nerf-simulator.utilization_percent' | translate }}</div>
                            <div class="kpi-value">{{ simulationResult.utilization_percent | number:'1.2-2' }}%</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6 col-lg-3 mb-3">
                        <div class="kpi-card kpi-success">
                          <div class="kpi-icon">
                            <mat-icon aria-hidden="true">groups</mat-icon>
                          </div>
                          <div class="kpi-content">
                            <div class="kpi-label">{{ 'components.nerf-simulator.patients_per_month' | translate }}</div>
                            <div class="kpi-value">{{ simulationResult.patients_per_month | number:'1.0-0' }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6 col-lg-3 mb-3">
                        <div class="kpi-card kpi-info">
                          <div class="kpi-icon">
                            <mat-icon aria-hidden="true">timer</mat-icon>
                          </div>
                          <div class="kpi-content">
                            <div class="kpi-label">{{ 'components.nerf-simulator.avg_infusion_time_mix' | translate }}</div>
                            <div class="kpi-value">{{ simulationResult.avg_infusion_time_mix | number:'1.1-1' }} <span class="unit">min</span></div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6 col-lg-3 mb-3">
                        <div class="kpi-card kpi-warning">
                          <div class="kpi-icon">
                            <mat-icon aria-hidden="true">rotate_right</mat-icon>
                          </div>
                          <div class="kpi-content">
                            <div class="kpi-label">{{ 'components.nerf-simulator.rotation_index' | translate }}</div>
                            <div class="kpi-value">{{ simulationResult.rotation_index | number:'1.2-2' }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row configuration-section">
                      <div class="col-12">
                        <mat-accordion class="expansion-panels-cards" multi>
                          <mat-expansion-panel class="expansion-panel-card">
                            <mat-expansion-panel-header>
                              <mat-panel-title class="d-flex align-items-center">
                                <mat-icon class="section-icon mr-2" aria-hidden="true">list</mat-icon>
                                {{ 'components.nerf-simulator.all_data' | translate }}
                              </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="nerf-all-data-panel-body">
                              <div class="nerf-all-data-capacity-block">
                                <div class="row mx-0">
                                  <div class="col-12 px-0">
                                    <h4 class="section-title section-title-purple mb-3">
                                      <mat-icon class="section-icon mr-2" aria-hidden="true">event_seat</mat-icon>
                                      {{ 'components.nerf-simulator.capacity_resources' | translate }}
                                    </h4>
                                  </div>
                                </div>
                                <div class="row mx-0">
                                  <div class="col-12 col-md-6 col-lg-4 mb-3">
                                    <div class="detail-card">
                                      <div class="detail-label">{{ 'components.nerf-simulator.effective_chairs' | translate }}</div>
                                      <div class="detail-value">{{ simulationResult.effective_chairs }}</div>
                                    </div>
                                  </div>
                                  <div class="col-12 col-md-6 col-lg-4 mb-3">
                                    <div class="detail-card">
                                      <div class="detail-label">{{ 'components.nerf-simulator.nurse_capacity' | translate }}</div>
                                      <div class="detail-value">{{ simulationResult.nurse_capacity }}</div>
                                    </div>
                                  </div>
                                  <div class="col-12 col-md-6 col-lg-4 mb-3">
                                    <div class="detail-card">
                                      <div class="detail-label">{{ 'components.nerf-simulator.cycles_per_chair_day' | translate }}</div>
                                      <div class="detail-value">{{ simulationResult.cycles_per_chair_day | number:'1.2-2' }}</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row p-3 pt-1">
                              @for (item of simulationResult | keyvalue; track item) {
                                <div class="col-12 col-md-6 col-lg-4 mb-2">
                                  <div class="param-item">
                                    <span class="param-label">{{ item.key }}:</span>
                                    <span class="param-value">{{ item.value | number:'1.2-6' }}</span>
                                  </div>
                                </div>
                              }
                              </div>
                            </div>
                          </mat-expansion-panel>
                        </mat-accordion>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
      }

    </div>
  </form>
</div>
